import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE2_2 = () => (
  <Section>

    <P>
      Mehrfachantworten sind möglich:
    </P>

    <UL disc gapAfter>
      <LI>Eltern</LI>
      <LI>Freunde und Bekannte</LI>
      <LI>Internetseiten von Online-Shops (Amazon, Zalando)</LI>
      <LI>Internetseiten von Modemarken und Bekleidungsgeschäften</LI>
      <LI>Zeitschriften/Magazine</LI>
      <LI>Soziale Netzwerke (Instagram, Facebook etc.)</LI>
      <LI>Fernsehen (Werbung, Promis?)</LI>
      <LI>Mode- oder Fashion-Blogs</LI>
    </UL>

    <P gapAfter>
      Erstellen Sie mit den Schülern eine <b>Statistik</b>, ggf. ein Balkendiagramm, um die Ergebnisse zu visualisieren.
    </P>

    <P>
      Welche Gruppe hat am meisten Einfluss? Werten Sie die Ergebnisse gemeinsam aus.
    </P>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE2_2.js